/**
 * @generated SignedSource<<8e7210ce96ec95435cf728f75294c71e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpNewArrivalsCarousel_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ItemHeartWrapper_viewer">;
  readonly " $fragmentType": "HpNewArrivalsCarousel_viewer";
};
export type HpNewArrivalsCarousel_viewer$key = {
  readonly " $data"?: HpNewArrivalsCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpNewArrivalsCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpNewArrivalsCarousel_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "loadPortfolioData",
          "value": true
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "userIds.0",
              "variableName": "userId"
            }
          ],
          "kind": "ListValue",
          "name": "userIds"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemHeartWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "fe8f2f6d2912ce892555ef047b96de75";

export default node;
